export default "__VITE_ASSET__BVz_urxz__"